module.exports = {
  SHARE_PLAN: 'SHARE_PLAN',
  NEW_TERMS_AND_CONDITIONS: 'NEW_TERMS_AND_CONDITIONS'
};
